import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  IconButton,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import footerImage from "../../Assets/footerbg.png";
import AssetConfig from "../../Theme/Assest";

const Footer = () => {
  const navigate = useNavigate();

  const productLinks = [
    {
      label: "Men",
      path: "/men",
    },
    {
      label: "Women",
      path: "/women",
    },
    {
      label: "Kid",
      path: "/kid",
    },
  ];

  const supportLinks = [
    {
      label: "About Us",
      path: "/about-us",
    },
    {
      label: "Privacy Policy",
      path: "/privacy/1",
    },
    {
      label: "Contact Us",
      path: "/contact-us",
    },
    {
      label: "Terms & Conditions",
      path: "/TermsConditions/1",
    },
    {
      label: "Return & Refund Policy",
      path: "/ReturnRefundPolicy/1",
    },
  ];

  const handleNavigation = (path) => {
    navigate(path);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleBackToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Box
      component="footer"
      sx={{
        position: "relative",
        overflow: "hidden",
        bgcolor: "#151515",
        color: "#fff",
      }}
    >
      {/* Decorative Background */}
      <Box
        sx={{
          position: "absolute",
          width: { xs: 260, md: 430 },
          height: { xs: 260, md: 430 },
          border: "1px solid rgba(255,255,255,0.045)",
          borderRadius: "50%",
          left: { xs: -180, md: -210 },
          bottom: { xs: -170, md: -220 },
          pointerEvents: "none",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          width: { xs: 280, md: 460 },
          height: { xs: 280, md: 460 },
          border: "1px solid rgba(255,255,255,0.04)",
          borderRadius: "50%",
          right: { xs: -190, md: -230 },
          top: { xs: -190, md: -230 },
          pointerEvents: "none",
        }}
      />

      <Container
        maxWidth="lg"
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* =========================
            MAIN FOOTER
        ========================== */}
        <Box
          sx={{
            py: {
              xs: 6,
              sm: 7,
              md: 8,
              lg: 9,
            },
          }}
        >
          <Grid
            container
            alignItems="flex-start"
            rowSpacing={{
              xs: 5,
              sm: 6,
              md: 0,
            }}
            columnSpacing={{
              xs: 0,
              sm: 4,
              md: 5,
              lg: 7,
            }}
          >
            {/* =========================
                BRAND SECTION
            ========================== */}
            <Grid item xs={12} sm={6} md={4}>
              <Box
                sx={{
                  maxWidth: 320,
                  textAlign: {
                    xs: "center",
                    sm: "left",
                  },
                  mx: {
                    xs: "auto",
                    sm: 0,
                  },
                }}
              >
                {/* Logo */}
                <Box
                  sx={{
                    width: {
                      xs: 64,
                      sm: 70,
                    },
                    height: {
                      xs: 64,
                      sm: 70,
                    },
                    bgcolor: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    mb: 2,
                    mx: {
                      xs: "auto",
                      sm: 0,
                    },
                  }}
                >
                  <Box
                    component="img"
                    src={AssetConfig.logoLight}
                    alt="Hindustan Wardrobe"
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </Box>

                {/* Brand Name */}
                <Typography
                  sx={{
                    fontSize: {
                      xs: 25,
                      sm: 27,
                    },
                    fontWeight: 400,
                    letterSpacing: "-0.045em",
                    lineHeight: 1,
                    color: "#fff",
                  }}
                >
                  Hindustan
                </Typography>

                <Typography
                  sx={{
                    fontSize: {
                      xs: 25,
                      sm: 27,
                    },
                    fontWeight: 400,
                    fontStyle: "italic",
                    letterSpacing: "-0.045em",
                    lineHeight: 1.05,
                    color: "rgba(255,255,255,0.9)",
                  }}
                >
                  Wardrobe.
                </Typography>

                {/* Description */}
                <Typography
                  sx={{
                    mt: 2.2,
                    maxWidth: 310,
                    fontSize: 11.5,
                    lineHeight: 1.8,
                    color: "rgba(255,255,255,0.58)",
                    mx: {
                      xs: "auto",
                      sm: 0,
                    },
                  }}
                >
                   India's most trusted luxury outfit rental. Designer-grade looks for every occasion, without the price of owning them.
                </Typography>

                {/* Social Label */}
                <Typography
                  sx={{
                    mt: 2.8,
                    mb: 1.3,
                    fontSize: 8,
                    fontWeight: 600,
                    letterSpacing: "0.23em",
                    textTransform: "uppercase",
                    color: "rgba(255,255,255,0.4)",
                  }}
                >
                  Follow Our Wardrobe
                </Typography>

                {/* Social Icons */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: {
                      xs: "center",
                      sm: "flex-start",
                    },
                    gap: 0.8,
                  }}
                >
                  <IconButton
                    component="a"
                    href="https://www.instagram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                    sx={{
                      width: 32,
                      height: 32,
                      border: "1px solid rgba(255,255,255,0.18)",
                      color: "rgba(255,255,255,0.65)",
                      borderRadius: "50%",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        color: "#fff",
                        borderColor: "rgba(255,255,255,0.55)",
                        bgcolor: "rgba(255,255,255,0.06)",
                        transform: "translateY(-3px)",
                      },
                    }}
                  >
                    <InstagramIcon sx={{ fontSize: 15 }} />
                  </IconButton>

                  <IconButton
                    component="a"
                    href="https://www.linkedin.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="LinkedIn"
                    sx={{
                      width: 32,
                      height: 32,
                      border: "1px solid rgba(255,255,255,0.18)",
                      color: "rgba(255,255,255,0.65)",
                      borderRadius: "50%",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        color: "#fff",
                        borderColor: "rgba(255,255,255,0.55)",
                        bgcolor: "rgba(255,255,255,0.06)",
                        transform: "translateY(-3px)",
                      },
                    }}
                  >
                    <LinkedInIcon sx={{ fontSize: 15 }} />
                  </IconButton>
                </Box>
              </Box>
            </Grid>

            {/* =========================
                PRODUCT
            ========================== */}
            <Grid item xs={6} sm={3} md={2}>
              <Box
                sx={{
                  textAlign: "left",
                }}
              >
                <Typography
                  sx={{
                    mb: 2.3,
                    fontSize: 9,
                    fontWeight: 600,
                    letterSpacing: "0.22em",
                    textTransform: "uppercase",
                    color: "rgba(255,255,255,0.43)",
                  }}
                >
                  Product
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: 1.25,
                  }}
                >
                  {productLinks.map((item) => (
                    <Box
                      key={item.label}
                      onClick={() => handleNavigation(item.path)}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.7,
                        cursor: "pointer",
                        "&:hover .footer-link": {
                          color: "#fff",
                          transform: "translateX(3px)",
                        },
                        "&:hover .footer-arrow": {
                          color: "rgba(255,255,255,0.75)",
                          transform: "translateX(2px)",
                        },
                      }}
                    >
                      <Typography
                        className="footer-link"
                        sx={{
                          fontSize: 11,
                          lineHeight: 1.5,
                          color: "rgba(255,255,255,0.72)",
                          transition: "all 0.25s ease",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item.label}
                      </Typography>

                      <Typography
                        className="footer-arrow"
                        component="span"
                        sx={{
                          fontSize: 10,
                          lineHeight: 1,
                          color: "rgba(255,255,255,0.25)",
                          transition: "all 0.25s ease",
                        }}
                      >
                        →
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Grid>

            {/* =========================
                SUPPORT
            ========================== */}
            <Grid item xs={6} sm={3} md={2}>
              <Box
                sx={{
                  textAlign: "left",
                }}
              >
                <Typography
                  sx={{
                    mb: 2.3,
                    fontSize: 9,
                    fontWeight: 600,
                    letterSpacing: "0.22em",
                    textTransform: "uppercase",
                    color: "rgba(255,255,255,0.43)",
                  }}
                >
                  Support
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: 1.15,
                  }}
                >
                  {supportLinks.map((item) => (
                    <Box
                      key={item.label}
                      onClick={() => handleNavigation(item.path)}
                      sx={{
                        cursor: "pointer",
                        "&:hover .support-link": {
                          color: "#fff",
                          transform: "translateX(3px)",
                        },
                      }}
                    >
                      <Typography
                        className="support-link"
                        sx={{
                          fontSize: 10.5,
                          lineHeight: 1.55,
                          color: "rgba(255,255,255,0.72)",
                          transition: "all 0.25s ease",
                        }}
                      >
                        {item.label}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Grid>

            {/* =========================
                FOOTER IMAGE
            ========================== */}
            <Grid item xs={12} sm={12} md={4}>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: {
                    xs: "center",
                    md: "flex-end",
                  },
                  alignItems: "flex-start",
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    width: {
                      xs: "100%",
                      sm: 300,
                      md: 285,
                      lg: 315,
                    },
                    height: {
                      xs: 165,
                      sm: 160,
                      md: 175,
                    },
                    overflow: "hidden",
                    bgcolor: "#202020",
                  }}
                >
                  <Box
                    component="img"
                    src={footerImage}
                    alt="Hindustan Wardrobe"
                    sx={{
                      width: "100%",
                      height: "100%",
                      display: "block",
                      objectFit: "cover",
                    }}
                  />

                  {/* Image Overlay */}
                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      background:
                        "linear-gradient(180deg, rgba(0,0,0,0.02) 20%, rgba(0,0,0,0.7) 100%)",
                    }}
                  />

                  {/* Image Caption */}
                  <Box
                    sx={{
                      position: "absolute",
                      left: 18,
                      bottom: 17,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 7.5,
                        fontWeight: 600,
                        letterSpacing: "0.2em",
                        textTransform: "uppercase",
                        color: "rgba(255,255,255,0.72)",
                        mb: 0.6,
                      }}
                    >
                      Your next look awaits
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 17,
                        lineHeight: 1.1,
                        fontStyle: "italic",
                        color: "#fff",
                      }}
                    >
                      Wear the moment.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* =========================
            DIVIDER
        ========================== */}
        <Divider
          sx={{
            borderColor: "rgba(255,255,255,0.11)",
          }}
        />

        {/* =========================
            BOTTOM BAR
        ========================== */}
        <Box
          sx={{
            minHeight: 72,
            py: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: {
              xs: "column",
              sm: "row",
            },
            gap: 2,
          }}
        >
          {/* Copyright */}
          <Typography
            sx={{
              fontSize: 8,
              color: "rgba(255,255,255,0.38)",
              letterSpacing: "0.04em",
              textAlign: {
                xs: "center",
                sm: "left",
              },
            }}
          >
            © {new Date().getFullYear()} Hindustan Wardrobe. All rights
            reserved.
          </Typography>

          {/* Tagline */}
          <Typography
            sx={{
              fontSize: 8,
              letterSpacing: "0.2em",
              textTransform: "uppercase",
              color: "rgba(255,255,255,0.38)",
              textAlign: "center",
            }}
          >
            Rent · Wear · Return
          </Typography>

          {/* Back To Top */}
          <IconButton
            onClick={handleBackToTop}
            aria-label="Back to top"
            sx={{
              width: 30,
              height: 30,
              borderRadius: "50%",
              border: "1px solid rgba(255,255,255,0.16)",
              color: "rgba(255,255,255,0.5)",
              transition: "all 0.3s ease",
              "&:hover": {
                color: "#fff",
                borderColor: "rgba(255,255,255,0.5)",
                bgcolor: "rgba(255,255,255,0.05)",
                transform: "translateY(-3px)",
              },
            }}
          >
            <KeyboardArrowUpIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
